import { DealHistoryTab } from '@/components/Deals/DealDetailPanel/DealHistoryTab'
import { CsSection } from '@/components/Cs/CsSection'

type Props = {
  accountId: string
  dealId: string
}

/** Mesma timeline da aba Histórico da negociação (cadastro → reuniões → contrato). */
export function CsAccountHistorico({ accountId, dealId }: Props) {
  return (
    <CsSection title='Histórico' collapsible defaultOpen={false}>
      <p className='mb-3 text-xs text-[var(--text-muted)]'>
        Desde a entrada do cliente: quem cadastrou, fluxo de reuniões e assinatura do contrato.
      </p>
      <DealHistoryTab dealId={dealId} timelinePath={`/cs/accounts/${accountId}/timeline`} />
    </CsSection>
  )
}
